import { openBlock, createBlock, Transition, withCtx, createElementBlock, normalizeStyle, createElementVNode, createCommentVNode, pushScopeId, popScopeId } from "vue";
/* empty css               */
/* empty css               */
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-loader",
  props: {
    show: {
      default: false,
      type: Boolean
    },
    height: {
      default: "40px",
      type: String
    },
    width: {
      default: "40px",
      type: String
    },
    transition: {
      default: true,
      type: Boolean
    },
    transparent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loaderSize() {
      return `width: ${this.width}; height: ${this.height}`;
    }
  }
};
const _withScopeId = (n) => (pushScopeId("data-v-4a50e07c"), n = n(), popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "circular-loader",
  viewBox: "25 25 50 50"
};
const _hoisted_2 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("circle", {
  cx: "50",
  cy: "50",
  r: "20",
  fill: "none",
  stroke: "#46BCAA26",
  "stroke-width": "2"
}, null, -1));
const _hoisted_3 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("circle", {
  class: "loader-path",
  cx: "50",
  cy: "50",
  r: "20",
  fill: "none",
  stroke: "#70c542",
  "stroke-width": "2"
}, null, -1));
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
const _hoisted_5 = {
  key: 1,
  viewBox: "0 0 1024 1024",
  focusable: "false",
  "data-icon": "loading",
  width: "100%",
  height: "100%",
  fill: "currentColor",
  "aria-hidden": "true",
  class: "transparent-loader"
};
const _hoisted_6 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("path", { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" }, null, -1));
const _hoisted_7 = [
  _hoisted_6
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, {
    name: $props.transition ? "loader-fade" : "",
    mode: "out-in"
  }, {
    default: withCtx(() => [
      $props.show ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "uikit-loader",
        style: normalizeStyle($options.loaderSize)
      }, [
        createElementVNode("div", {
          class: "loader",
          style: normalizeStyle($options.loaderSize)
        }, [
          !$props.transparent ? (openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4)) : (openBlock(), createElementBlock("svg", _hoisted_5, _hoisted_7))
        ], 4)
      ], 4)) : createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["name"]);
}
const Loader = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-4a50e07c"]]);
export {
  Loader as default
};
//# sourceMappingURL=Loader.vue.es.js.map
